module.exports = __webpack_public_path__ + "img/font-shadow-color.a43bfae6.svg";